import React, { useEffect, useRef, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import logo from '../media/MarketLab_logo_.png';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import { Link } from 'react-router-dom';
import SettingsIcon from '@mui/icons-material/Settings'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import LogoutIcon from '@mui/icons-material/Logout'
import PaymentIcon from '@mui/icons-material/Payment'
import SupportIcon from '@mui/icons-material/Support'
import ChatBubbleIcon from '@mui/icons-material/ChatBubble'
import { useSelector } from 'react-redux';

function Header({ fr }) {
    const [settingsOpen, setSettingsOpen] = useState(false)


    const settingsRef = useRef(null);


    const user = useSelector(state=> state.user.user)


    const cPath = window.location.pathname.split('/').pop()

    useEffect(() => {
        const handleClickOutside = (event) => {
          if (settingsRef.current && !settingsRef.current.contains(event.target)) {
            setSettingsOpen(false);
          }
        };
    
        // Add event listener to detect clicks outside of the settings popup
        document.addEventListener('mousedown', handleClickOutside);
    
        return () => {
          // Remove event listener when component unmounts
          document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    useEffect(()=> {
        setSettingsOpen(false)
    }, [window.location.pathname])


    async function logout() {
        await signOut(auth);
        window.location.href = '/login';
    }

    const linkStyles = {
        textDecoration: 'none',
        color: 'white',
        margin: '0',
        padding: '0'
    };

    return (
        <HeaderContainer settings={settingsOpen}  ref={settingsRef}>
            <LeftHeader>
                <Ray ty={'20'} tr={'5'} w={'300'} d={'8'}/>
                <Ray ty={'0'} tr={'310'} w={'500'} d={'6'}/>
                <Ray ty={'-15'} tr={'300'} w={'360'} d={'5'}/>

                <Ray ty={'-76'} tr={'300'} w={'460'} d={'5'}/>
                <Ray ty={'-95'} tr={'300'} w={'460'} d={'5'}/>
                <Ray ty={'50'} tr={'300'} w={'290'} d={'5'}/>
                <Ray ty={'10'} tr={'300'} w={'300'} d={'5'}/>
                <Ray ty={'90'} tr={'300'} w={'300'} d={'5'}/>
                <Link to='/' style={linkStyles} onClick={()=> fr()}><img src={logo} width={200} alt='logo' style={{ filter: 'contrast(200%)', filter: 'saturate(100%)' }} /></Link>
            </LeftHeader>
            <RightHeader>
                {user.role === 'manager' && <Link to='/management' style={linkStyles} onClick={()=> fr()}><p style={{color: cPath === 'management'?'rgb(255, 77, 112)': 'white'}}>Management</p></Link>}
                {!user.prem && <Link to='/pricing' style={linkStyles} onClick={()=> fr()}><p style={{color: cPath === 'pricing'? '#f7f1ab': 'white'}}>Upgrade</p></Link>}
                {!user.prem && <Link to='/store' style={linkStyles} onClick={()=> fr()}><p style={{color: cPath === 'store'? '#de2699': 'white'}}>Store</p></Link>}
                {<Link to='https://improwth.com/market-lab/docs' target='_blank' style={linkStyles}><p>Docs</p></Link>}
            </RightHeader>
            <Profile settings={settingsOpen} ref={settingsRef}>
                <SettingsIcon onClick={()=> setSettingsOpen(prev=> !prev)}/>
                {settingsOpen && <div>
                    <Link to='/account-settings' style={linkStyles} className='link' onClick={()=> fr()}><p><ManageAccountsIcon /> Account Settings</p></Link>
                    {user.prem && <Link to='/subscription-settings' style={linkStyles} className='link' onClick={()=> fr()}><p><PaymentIcon /> Subscription Settings</p></Link>}
                    <Link to='/feedback' style={linkStyles} className='link' onClick={()=> fr()}><p><ChatBubbleIcon /> Feedback</p></Link>
                    <Link to='/support' style={linkStyles} className='link' onClick={()=> fr()}><p><SupportIcon /> Support</p></Link>
                    <p onClick={logout}><LogoutIcon /> Logout</p>
                </div>}              
            </Profile>
        </HeaderContainer>
    );
}

export default Header;


const SlideDown = keyframes`
    from {
        height: 37px;
    }

    to {
        height: 200px;
    }
`

const SlideUp = keyframes`
    from {
        height: 200px;
    }

    to {
        height: 37px;
    }
`


const FadeEffect = keyframes`
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
`

const HeaderContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px;
    background: 
    radial-gradient(
        circle at 0%,
        #fffff1 0%,
        #fffff1 15%,
        var(--ml-color) 50%,
        var(--ml-color) 100%
    );
    perspective: 400px;
    transform-style: preserve-3d;
    overflow: hidden;
    position: relative;
    transition: height 0.3s ease-in-out;
    animation: ${props=> props.settings? SlideDown: SlideUp} 0.3s forwards;
`;

const rayAnimation = keyframes`
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0;
    }

    75% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
`

const Ray = styled.div`
    position: absolute;
    width: ${props=> props.w}px;
    height: 10px;
    left: 20%;
    transform: rotate(${props => props.tr}deg); // 340 - 10
    transform: translateY(${props => props.ty}px);
    background: linear-gradient(90deg, #fffff1, transparent);

    opacity: 0;
    animation: ${rayAnimation} ${props=> props.d}s ease-in-out alternate infinite;
`


const LeftHeader = styled.div`
    display: flex;
    flex: 0.3;
    position: relative;

    > img {
        z-index: 5;
    }
`;

const RightHeader = styled.div`
    display: flex;
    flex: 0.7;
    justify-content: center;
    gap: 50px;
`;


const Profile = styled.div`
    width: 200px;
    margin-left: auto;
    display: flex;
    justify-content: right;

    > .MuiSvgIcon-root {
        color: white;
        position: relative;
        transform: ${props=> props.settings? 'rotate(-90deg)': ''};
        cursor: pointer;

        &:hover {
            color: rgba(255, 255, 255, 0.8);
        }
    }

    > div {
        position: absolute;
        width: 200px;
        height: 300px;
        border: none;
        border-radius: 3px;
        top: 40px;
        right: 30px;
        z-index: 100;
        color: white;

        opacity: 0;
        animation: ${FadeEffect} 0.3s ease-in-out forwards;

        > .link > p {
            cursor: pointer;
            margin-bottom: 10px;
            width: fit-content;
            display: flex;
            align-items: center;
            gap: 10px;

            &:hover {
                color: rgba(255, 255, 255, 0.8);
            }
        }
         > p {
            cursor: pointer;
            margin-bottom: 10px;
            width: fit-content;
            display: flex;
            align-items: center;
            gap: 10px;

            &:hover {
                color: rgba(255, 255, 255, 0.8);
            }
        }
    }
`